var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4202 6.38372C11.5427 5.50622 10.3952 5.06372 9.24023 5.06372V9.56372L6.06023 12.7437C7.81523 14.4987 10.6652 14.4987 12.4277 12.7437C14.1827 10.9887 14.1827 8.13872 12.4202 6.38372ZM9.24023 2.06372C5.10023 2.06372 1.74023 5.42372 1.74023 9.56372C1.74023 13.7037 5.10023 17.0637 9.24023 17.0637C13.3802 17.0637 16.7402 13.7037 16.7402 9.56372C16.7402 5.42372 13.3802 2.06372 9.24023 2.06372ZM9.24023 15.5637C5.92523 15.5637 3.24023 12.8787 3.24023 9.56372C3.24023 6.24872 5.92523 3.56372 9.24023 3.56372C12.5552 3.56372 15.2402 6.24872 15.2402 9.56372C15.2402 12.8787 12.5552 15.5637 9.24023 15.5637Z",
    fill: "#534AD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelapse);
export default __webpack_public_path__ + "static/media/timelapse.bb3a3f3563f7daa397a9dd064aaf294a.svg";
export { ForwardRef as ReactComponent };